export const adminRoutes = [
  {
    path: '/app/admin',
    name: 'admin',
    component: () => import('../../views/Admin/AdminView.vue'),
    meta: { requiresAuth: true, requiresAdmin: true }
  },
  {
    path: '/app/admin/user/:id',
    name: 'user-detail',
    component: () => import('../../views/Admin/UserDetailView.vue'),
    props: true,
    meta: { requiresAuth: true, requiresAdmin: true }
  }
]
